import api from '@/api'

export default {
  name: 'LojaSearchSelect',
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Buscar loja por nome ou ID',
    },
  },
  data() {
    return {
      termoBusca: '',
      resultados: [],
      listaAberta: false,
      carregando: false,
      indiceDestaque: -1,
      buscaTimeout: null,
      ignorarProximaBusca: false,
      lojaSelecionada: null,
    }
  },
  computed: {
    mensagemVazia() {
      if ((this.termoBusca || '').trim().length < 2) {
        return 'Digite ao menos 2 caracteres para buscar'
      }

      return 'Nenhuma loja encontrada'
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(novoValor) {
        this.sincronizarValor(novoValor)
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.buscaTimeout)
  },
  methods: {
    async sincronizarValor(lojaId) {
      if (!lojaId) {
        this.lojaSelecionada = null
        if (!this.listaAberta) {
          this.termoBusca = ''
        }
        return
      }

      if (this.lojaSelecionada && String(this.lojaSelecionada.id) === String(lojaId)) {
        return
      }

      await this.carregarLojaPorId(lojaId)
    },
    async carregarLojaPorId(lojaId) {
      try {
        const response = await api.get('/painel/ia/relatorios/lojas', {
          params: { id: lojaId },
        })
        const loja = response.data[0]

        if (loja) {
          this.definirSelecionada(loja, false)
        }
      } catch (error) {
        console.error('Erro ao carregar loja:', error)
      }
    },
    definirSelecionada(loja, emitir = true) {
      this.lojaSelecionada = loja
      this.ignorarProximaBusca = true
      this.termoBusca = `${loja.id} - ${loja.nome}`
      this.resultados = []
      this.listaAberta = false
      this.indiceDestaque = -1

      if (emitir && String(this.value) !== String(loja.id)) {
        this.$emit('input', loja.id)
        this.$emit('change', loja.id)
      }
    },
    onFocus() {
      this.listaAberta = true

      if (this.lojaSelecionada) {
        this.termoBusca = ''
        this.resultados = []
      }
    },
    onInput() {
      if (this.ignorarProximaBusca) {
        this.ignorarProximaBusca = false
        return
      }

      this.lojaSelecionada = null
      this.listaAberta = true
      this.indiceDestaque = -1
      clearTimeout(this.buscaTimeout)

      const termo = (this.termoBusca || '').trim()
      if (termo.length < 2) {
        this.resultados = []
        this.carregando = false
        return
      }

      this.carregando = true
      this.buscaTimeout = setTimeout(() => {
        this.buscarLojas(termo)
      }, 300)
    },
    async buscarLojas(termo) {
      try {
        const response = await api.get('/painel/ia/relatorios/lojas', {
          params: {
            search: termo,
            limit: 20,
          },
        })

        this.resultados = response.data
        this.indiceDestaque = this.resultados.length ? 0 : -1
      } catch (error) {
        console.error('Erro ao buscar lojas:', error)
        this.resultados = []
      } finally {
        this.carregando = false
      }
    },
    selecionar(loja) {
      this.definirSelecionada(loja)
    },
    navegar(direcao) {
      if (!this.resultados.length) {
        return
      }

      this.listaAberta = true
      const total = this.resultados.length
      const proximo = this.indiceDestaque + direcao

      if (proximo < 0) {
        this.indiceDestaque = total - 1
        return
      }

      this.indiceDestaque = proximo % total
    },
    confirmarDestaque() {
      if (this.indiceDestaque >= 0 && this.resultados[this.indiceDestaque]) {
        this.selecionar(this.resultados[this.indiceDestaque])
      }
    },
    fecharLista() {
      this.listaAberta = false
      this.indiceDestaque = -1
    },
    onBlur() {
      setTimeout(() => {
        this.fecharLista()

        if (this.lojaSelecionada) {
          this.termoBusca = `${this.lojaSelecionada.id} - ${this.lojaSelecionada.nome}`
          return
        }

        if (this.value) {
          this.sincronizarValor(this.value)
        }
      }, 150)
    },
  },
}
